import DataApi from './DataApi';

class AuditApi extends DataApi {
  constructor() {
    super('audit');
  }

  fetchMeta() {
    return this.get('/meta');
  }

  fetchLogs(params = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        qs.set(key, String(value));
      }
    });
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.get(`/logs${suffix}`);
  }

  fetchLogById(id) {
    return this.get(`/logs/${encodeURIComponent(id)}`);
  }

  restoreFromAuditLog(id) {
    return this.post(`/logs/${encodeURIComponent(id)}/restore`, {});
  }

  logDataExport(payload = {}) {
    return this.post('/data-export', payload);
  }

  fetchLoginHistory(params = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        qs.set(key, String(value));
      }
    });
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.get(`/login-history${suffix}`);
  }
}

export default AuditApi;
